module.exports = __webpack_public_path__ + "static/media/Group220.e4dc0be3.svg";